<template>
  <div class="app-container">
    <el-form :inline="false" label-position="top" size="small">
      <el-row :gutter="20">
        <el-col :span="4">
          <!--  业务类型  -->
          <el-form-item :label="$t('collectionCenter.businessT')">
            <el-select
              v-model="queryForm.params.type"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              style="width: 100%"
            >
              <el-option :label="$t('collectionCenter.lanshou')" :value="0" />
              <el-option :label="$t('collectionCenter.dispatch')" :value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('collectionCenter.displayRange')">
            <el-select
              v-model="queryForm.params.displayScopeList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              multiple
              collapse-tags
              style="width: 100%"
            >
              <el-option
                v-for="(item, idx) in displayRangeList"
                :key="idx"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--  状态   -->
          <el-form-item :label="$t('GlobalSetObj.status')">
            <el-select
              v-model="queryForm.params.status"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              style="width: 100%"
            >
              <el-option :label="$t('GlobalSetObj.enable')" :value="0" />
              <el-option :label="$t('GlobalSetObj.stop')" :value="1" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--问题件原因-->
          <el-form-item :label="$t('GlobalSetObj.problemReason')">
            <el-input
              v-model="queryForm.params.value"
              :placeholder="$t('GlobalSetObj.pleaseInput')"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <div style="margin-top: 28px">
            <!--搜索-->
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="enterSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh-left" size="small" type="info"
              @click="resetForm"
            >{{ $t('newOrder.reset') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="15">
          <el-button
            v-permit:remove="'btn:problemConfiguration:addProblem'"
            size="small"
            style="margin-bottom: 15px"
            type="primary"
            @click="addProblem"
          >{{ $t('changepwd.addProblem') }}
          </el-button>
          <!--导出-->
          <el-button
            v-permit:remove="'btn:problemConfiguration:export'"
            size="small"
            style="margin-bottom: 15px"
            plain
            @click="exportProblemConfig"
          >{{ $t('collectionCenter.export') }}
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <!--  表格数据  -->
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      :height="620"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="70"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="false"
      >
        <template v-if="item.prop === 'problemRecordLimit'" slot="header">
          <div>
            {{ $t('GlobalSetObj.DeliveryTimes') }}
            <el-tooltip :content="$t('collectionCenter.problemItem')" placement="top">
              <span class="deliveryTimesTips">?</span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <div v-if="item.prop === 'status'">
            <div v-if="scope.row.status === 1" style="color: #f56c6c">
              {{ $t('GlobalSetObj.stop') }}
            </div>
            <div v-else style="color: #409eff">{{ $t('GlobalSetObj.enable') }}</div>
          </div>
          <div v-else-if="item.prop === 'zhValue'">
            <div class="limit-lines">{{ scope.row.zhValue }}</div>
          </div>
          <div v-else-if="item.prop === 'puValue'">
            <div class="limit-lines">{{ scope.row.puValue }}</div>
          </div>
          <div v-else-if="item.prop === 'remark'">
            <div class="limit-lines">{{ scope.row.remark }}</div>
          </div>
          <div v-else class="limit-lines">
            {{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('newOrder.operation')" align="center" fixed="right"
        width="100"
      >
        <template slot-scope="scope">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <el-tooltip
              :content="$t('GlobalSetObj.edit')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-edit textOperator" @click="editMessage(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.status === 1"
              :content="$t('GlobalSetObj.enable')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-circle-check textOperator" @click="updateStatus(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-else
              :content="$t('GlobalSetObj.stop')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-remove-outline textOperator1" @click="updateStatus(scope.row)" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 新增问题件 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="dialogTitle"
      :visible.sync="addCusTimeDialog"
      top="30px"
      width="750px"
      @close="handleCloseDialog"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        label-position="top"
        label-width="auto"
      >
        <div style="height: 650px; padding: 0 10px; overflow: auto; width: 100%">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('collectionCenter.businessT')" prop="type">
                <el-select
                  v-model="ruleForm.type"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                  @change="typeChange"
                >
                  <el-option :label="$t('collectionCenter.lanshou')" :value="0" />
                  <el-option :label="$t('collectionCenter.dispatch')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="ruleForm.type === 1" :span="12">
              <el-form-item :label="$t('collectionCenter.problemPieceType')" prop="category">
                <el-select
                  v-model="ruleForm.category" style="width: 100%"
                  @change="categoryChange"
                >
                  <el-option :label="$t('changepwd.putongProblem')" :value="0" />
                  <el-option :label="$t('changepwd.teshuProblem')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="ruleForm.type === 1 && ruleForm.category === 0" :span="12">
              <el-form-item :label="$t('collectionCenter.displayRange')" prop="displayScope">
                <el-select
                  v-model="ruleForm.displayScope"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable multiple collapse-tags style="width: 100%"
                >
                  <el-option
                    v-for="(item, idx) in displayRangeList"
                    :key="idx" :label="item.label" :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--数字代码-->
              <el-form-item :label="$t('changepwd.numCode')" prop="numCode">
                <el-input
                  v-model="ruleForm.numCode"
                  :disabled="isDisable"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--问题件代码-->
              <el-form-item :label="$t('changepwd.problemCode')" prop="code">
                <el-input
                  v-model="ruleForm.code"
                  :disabled="isDisable"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                  maxlength="50"
                  show-word-limit
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--  状态   -->
              <el-form-item :label="$t('GlobalSetObj.status')" prop="status">
                <el-select
                  v-model="ruleForm.status"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                >
                  <el-option :label="$t('GlobalSetObj.enable')" :value="0" />
                  <el-option :label="$t('GlobalSetObj.stop')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!--排序-->
              <el-form-item :label="$t('GlobalSetObj.sort')" prop="sort">
                <el-select
                  v-model="ruleForm.sort"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item, idx) in 30"
                    :key="idx"
                    :label="item.toString()"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('collectionCenter.validReturnReason')" prop="returnReasonFlag">
                <el-select
                  v-model="ruleForm.returnReasonFlag"
                  clearable
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  style="width: 100%"
                  @change="returnReasonFlagChange"
                >
                  <el-option :label="$t('Resource.No')" :value="0" />
                  <el-option :label="$t('Resource.yes')" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--问题件原因（中文）-->
              <el-form-item :label="$t('changepwd.problemReasonZH')" prop="zhValue">
                <el-input
                  v-model="ruleForm.zhValue"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                  maxlength="200"
                  show-word-limit
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--问题件原因（英文）-->
              <el-form-item :label="$t('changepwd.problemReasonEN')" prop="enValue">
                <el-input
                  v-model="ruleForm.enValue"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                  maxlength="200"
                  show-word-limit
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--问题件原因（葡语）-->
              <el-form-item :label="$t('changepwd.problemReasonPU')" prop="puValue">
                <el-input
                  v-model="ruleForm.puValue"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  clearable
                  maxlength="200"
                  show-word-limit
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <!--备注-->
              <el-form-item :label="$t('GlobalSetObj.remark')" prop="remark">
                <el-input
                  v-model="ruleForm.remark"
                  :placeholder="$t('GlobalSetObj.pleaseInput')"
                  :rows="3"
                  clearable
                  maxlength="500"
                  show-word-limit
                  style="width: 100%"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="border-top: 1px solid #bbb;padding-top: 20px">
          <el-row>
            <el-col v-if="ruleForm.returnReasonFlag !== 0" :span="12">
              <!--派送次数-->
              <el-form-item
                :label="$t('GlobalSetObj.DeliveryTimes')"
                prop="problemRecordLimit"
                :rules="{
                  required: ruleForm.returnReasonFlag !== 0,
                  message: $t('GlobalSetObj.pleaseChoose'),
                  trigger: 'change'
                }"
              >
                <template slot="label">
                  <span>
                    {{ $t('GlobalSetObj.DeliveryTimes') }}
                    <el-tooltip :content="$t('collectionCenter.problemItem')" placement="top">
                      <span class="deliveryTimesTips">?</span>
                    </el-tooltip>
                  </span>
                </template>
                <el-select
                  v-model="ruleForm.problemRecordLimit"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                  clearable
                  style="width: 100%"
                >
                  <el-option label="1" :value="1" />
                  <el-option label="2" :value="2" />
                  <el-option label="3" :value="3" />
                  <el-option label="4" :value="4" />
                  <el-option label="5" :value="5" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="ruleForm.returnReasonFlag !== 0 ? 12 : 24">
              <div style="text-align: right;margin-top: 28px">
                <el-button size="small" @click="cusSubmit(1)">{{ $t('GlobalSetObj.cancel') }}</el-button>
                <el-button
                  size="small" type="primary" @click="cusSubmit(2)"
                >{{ $t('GlobalSetObj.confirm') }}
                </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getproblemChangeAdd,
  getproblemChangeStatus,
  getproblemCongfigPage,
  getproblemExport,
  problemChangeUpdate
} from '@/api/resources';
import { problemtypeLeixingObj, problemtypesObj } from '@/utils/enumData';
import { check999Number, check99Number, checkStrNumber } from '@/utils/validate';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'ProblemConfiguration',
  data() {
    return {
      displayRangeList: [
        { label: this.$t('collectionCenter.expressSystemDesktop'), value: 1 }, // 快递系统PC
        { label: this.$t('collectionCenter.expressMobileApp'), value: 2 }, // 快递系统APP
        { label: this.$t('collectionCenter.dot'), value: 3 }, // 网点
        { label: this.$t('collectionCenter.deliveryMan'), value: 4 } // 派送员
      ],
      // 是否格式化成巴西时间
      isTormat: false,
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          type: '', // 问题件类型（0-揽收 1-派送）
          displayScopeList: [],
          status: null, // 状态
          value: '' // 问题件原因
        }
      },
      tableData: [],
      tableHeaderList: [
        // 问题件类型
        { id: 1, label: this.$t('collectionCenter.problemPieceType'), prop: 'categoryName', cloWidth: '160' },
        // 展示范围
        { id: 1, label: this.$t('collectionCenter.displayRange'), prop: 'displayScopeName', cloWidth: '150' },

        // 业务类型
        {
          id: 2,
          label: this.$t('collectionCenter.businessT'),
          prop: 'typeName',
          cloWidth: '150'
        },
        // 数字代码
        {
          id: 4,
          label: this.$t('changepwd.numCode'),
          prop: 'numCode',
          cloWidth: '150'
        },
        // 派送次数
        {
          id: 5,
          label: this.$t('GlobalSetObj.DeliveryTimes'),
          prop: 'problemRecordLimit',
          cloWidth: '150'
        },
        // 问题件代码
        {
          id: 8,
          label: this.$t('changepwd.problemCode'),
          prop: 'code',
          cloWidth: '150'
        },
        // 问题件原因（中文）
        {
          id: 9,
          label: this.$t('changepwd.problemReasonZH'),
          prop: 'zhValue',
          cloWidth: '150'
        },
        // 问题件原因（葡语）
        {
          id: 11,
          label: this.$t('changepwd.problemReasonPU'),
          prop: 'puValue',
          cloWidth: '150'
        },
        // 备注
        {
          id: 12,
          label: this.$t('GlobalSetObj.remark'),
          prop: 'remark',
          cloWidth: '150'
        },
        // 排序值
        {
          id: 13,
          label: this.$t('changepwd.sortValue'),
          prop: 'sort',
          cloWidth: '150'
        },
        // 状态
        {
          id: 14,
          label: this.$t('GlobalSetObj.status'),
          prop: 'status',
          cloWidth: '100'
        },
        // 创建时间
        {
          id: 15,
          label: this.$t('GlobalSetObj.CreationTime'),
          prop: 'createTime',
          cloWidth: '150'
        },
        // 创建人
        {
          id: 16,
          label: this.$t('GlobalSetObj.CreatePeople'),
          prop: 'createUserName',
          cloWidth: '150'
        },
        // 更新时间
        {
          id: 17,
          label: this.$t('GlobalSetObj.UpdateTime'),
          prop: 'updateTime',
          cloWidth: '150'
        },
        // 更新人
        {
          id: 18,
          label: this.$t('GlobalSetObj.Updater'),
          prop: 'updateUserName',
          cloWidth: '150'
        }
      ],
      userList: [], // 用户列表
      customerMerchant: [],
      addCusTimeDialog: false,
      dialogTitle: this.$t('changepwd.addProblem'),
      ruleForm: {
        category: '',
        type: '',
        numCode: '',
        code: '',
        zhValue: '',
        puValue: '',
        remark: null,
        sort: null,
        status: null,
        problemRecordLimit: 1,
        displayScope: [],
        returnReasonFlag: null
      },
      rules: {
        category: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        displayScope: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        type: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        numCode: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' },
          {
            validator: check999Number,
            trigger: 'change' // 触发时机与 required 规则一致
          }
        ],
        code: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' },
          {
            validator: checkStrNumber,
            trigger: 'change' // 触发时机与 required 规则一致
          }
        ],
        status: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        sort: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' },
          {
            validator: check999Number,
            trigger: 'change' // 触发时机与 required 规则一致
          }
        ],
        returnReasonFlag: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        // problemRecordLimit: [
        //   { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' },
        //   {
        //     validator: check99Number,
        //     trigger: 'change' // 触发时机与 required 规则一致
        //   }
        // ],
        zhValue: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' }
        ],
        puValue: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' }
        ],
        remark: [
          { required: false, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' }
        ]
      },
      detailData: [],
      editId: null,
      isDisable: false,
      parentValue: ''
    };
  },
  computed: {
    IsWidth() {
      return {
        width: this.isTormat ? '180px' : '110px'
      };
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getSearch();
  },
  methods: {
    typeChange(val) {
      if (val !== 1) {
        this.ruleForm.category = '';
        this.ruleForm.displayScope = [];
      }
    },
    returnReasonFlagChange(val) {
      if (val === 0) {
        this.ruleForm.problemRecordLimit = null;
      } else {
        this.ruleForm.problemRecordLimit = 1;
      }
    },
    categoryChange(val) {
      if (val !== 0) {
        this.ruleForm.displayScope = [];
      }
    },
    // 导出问题件配置
    exportProblemConfig() {
      getproblemExport(this.queryForm.params).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    addProblem() {
      this.dialogTitle = this.$t('changepwd.addProblem');
      this.isDisable = false;
      this.editId = null;
      this.updateRules(true);
      this.addCusTimeDialog = true;
    },
    // 点击确定
    cusSubmit(val) {
      if (val === 1) {
        this.addCusTimeDialog = false;
      } else {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            const data = {
              ...this.ruleForm
            };
            data.displayScope = this.ruleForm.displayScope && this.ruleForm.displayScope.length > 0 ? this.ruleForm.displayScope.join(',') : null;
            if (this.dialogTitle === this.$t('changepwd.addProblem')) {
              getproblemChangeAdd(data).then((res) => {
                if (res.code === 200) {
                  this.addCusTimeDialog = false;
                  this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully'));
                  this.getSearch();
                }
              });
            } else {
              data.id = this.editId;
              problemChangeUpdate(data).then((res) => {
                if (res.code === 200) {
                  this.addCusTimeDialog = false;
                  this.$message.success(this.$t('GlobalSetObj.SaveSuccessfully'));
                  this.getSearch();
                }
              });
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    // 编辑
    editMessage(row) {
      console.log(row, 'row编辑');
      this.dialogTitle = this.$t('changepwd.editProblem');
      this.isDisable = true;
      this.parentValue = row.parentValue || '--';
      this.editId = row.id;
      this.ruleForm = {
        category: row.category,
        type: row.type,
        numCode: row.numCode,
        code: row.code,
        zhValue: row.zhValue,
        puValue: row.puValue,
        remark: row.remark,
        sort: row.sort,
        status: row.status,
        problemRecordLimit: row.problemRecordLimit,
        displayScope: row.displayScope ? row.displayScope.split(',').map(Number) : [],
        returnReasonFlag: row.returnReasonFlag
      };
      this.updateRules(true);
      this.addCusTimeDialog = true;
    },
    updateRules(flage) {
      // 使用 Vue.set 确保响应式
      this.$set(this.rules, 'type', [
        { required: flage, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
      ]);
      this.$set(this.rules, 'category', [
        { required: flage, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
      ]);
      if (flage) {
        this.$set(this.rules, 'numCode', [
          { required: flage, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' },
          {
            validator: check999Number,
            trigger: 'change' // 触发时机与 required 规则一致
          }
        ]);
        this.$set(this.rules, 'problemRecordLimit', [
          { required: flage, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' },
          {
            validator: check99Number,
            trigger: 'change' // 触发时机与 required 规则一致
          }
        ]);
        this.$set(this.rules, 'code', [
          { required: flage, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' },
          {
            validator: checkStrNumber,
            trigger: 'change' // 触发时机与 required 规则一致
          }
        ]);
      } else {
        this.$set(this.rules, 'numCode', [
          { required: flage, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' }
        ]);
        this.$set(this.rules, 'code', [
          { required: flage, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' }
        ]);
      }
    },
    // 启用停用
    updateStatus(row) {
      const data = {
        id: row.id,
        status: row.status === 1 ? 0 : 1
      };
      this.$confirm(this.$t('changepwd.areYouSureProblemTip'), this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'), // '确定'
        cancelButtonText: this.$t('collectionCenter.cancel'), // '取消'
        type: 'warning'
      })
        .then(async() => {
          getproblemChangeStatus(data).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.ModificationSuccessful'));
              this.getSearch();
            }
          });
        })
        .catch(() => {
          console.log('取消关闭');
        });
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.timeValue = [];
      this.queryForm.params = {
        type: '', // 问题件类型（0-揽收 1-派送）
        displayScopeList: [],
        status: null, // 状态
        value: '' // 问题件原因
      };
      this.getSearch();
    },
    // 查询
    getSearch() {
      const data = {
        params: {}
      };
      data.pageSize = this.queryForm.pageSize;
      data.pageNumber = this.queryForm.pageNumber;
      data.params = this.queryForm.params;
      getproblemCongfigPage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          this.tableData.forEach((item) => {
            if (item.category !== null) {
              item.categoryName = problemtypeLeixingObj[item.category];
            }
            if (item.type !== null) {
              item.typeName = problemtypesObj[item.type];
            }
          });
        }
      });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    handleCloseDialog() {
      this.ruleForm = {
        category: '',
        type: '',
        numCode: '',
        code: '',
        zhValue: '',
        puValue: '',
        remark: null,
        sort: null,
        status: null,
        problemRecordLimit: 1,
        displayScope: [],
        returnReasonFlag: null
      };
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 0 15px;
  padding-bottom: 15px;
}

::v-deep {
  .drawerClass header {
    border-bottom: 1px solid #aaa !important;
    margin-bottom: 0 !important;
    padding: 20px 20px 20px !important;
  }
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep .el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

.textOperator {
  color: #409eff;
  cursor: pointer;
  font-size: 22px;
}

.textOperator1 {
  color: #f56c6c;
  cursor: pointer;
  font-size: 22px;
}

.messgeList {
  height: 450px;
  background-color: #f5f5f5;
  margin-bottom: 20px;
  border-radius: 10px;
  padding: 10px;
  overflow-y: auto;
}

.downLink {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
  cursor: pointer;
  padding: 5px;
}

.downModule {
  color: #409eff;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 15px;
}

.limit-lines {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
}
.deliveryTimesTips {
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #aaa;
  font-size: 12px;
}
</style>
